import React from "react";
import styled from "styled-components";
import ClipLoader from "react-spinners/ClipLoader";
import './ButtonAction.scss'

const StyledButton = styled.button`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  width: ${props => props.width? props.width:'max-content'};
  padding: 6px 8px;
  cursor:pointer;
  margin:${props => props.margin? props.margin:'auto'};
  background:transparent;
  color:white;
  border:none;
 
`;
const ButtonAction = (props) =>{
  return (
    <>
    <StyledButton 
      onClick = {props.onClick} 
      width={props.width}
      border={props.border}
      flat={props.flat}
      margin={props.margin}
      disabled={props.disabled}
      style={props.style}
      className="tooltip-ba"
    >
      <div className={'ba-badge'} style={{display:(props.showBadge?'':'none')}}></div>
      <span className="tooltiptext">{props.tooltip}</span>
      {
        props.loading?
        (<ClipLoader color={props.flat?"white":"#0288d1"} speedMultiplier={1}  size={15}/>)
        :
        (props.children)
      }
    </StyledButton >
    
    </>
  );
};
export default ButtonAction;